import React from 'react';

const KnowledgeHubAdminAccessContext = React.createContext(false);

export const KnowledgeHubAdminAccessProvider = KnowledgeHubAdminAccessContext.Provider;

export function useKnowledgeHubAdminAccess(): boolean {
  return React.useContext(KnowledgeHubAdminAccessContext);
}
